/* Warenkorb-Verhalten, auf jeder Seite geladen (27.09.2026).
   Vorher als {% javascript %} in den Snippets gft-cart-complements und gft-cart-assurance: Shopify führt solche
   Snippet-Skripte nur aus, wenn das Snippet beim Seitenaufruf schon gerendert war. Wurde der Warenkorb erst nach
   dem Laden gefüllt (Seitenfenster per AJAX), fehlten die Klick-Handler: «Hinzufügen» beim Vorschlag tat nichts,
   und die Grössenprüfung vor der Kasse griff nicht. */
(function(){
let gftAddingComplement = false;
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-gft-cart-add]');
  if (!button || gftAddingComplement) return;
  gftAddingComplement = true;
  const error = button.closest('.gft-cart-additions').querySelector('[data-gft-add-error]');
  error.hidden = true;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    const drawer = button.closest('cart-drawer');
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: Number(button.dataset.gftCartAdd), quantity: 1}], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname})
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error('Cart addition failed');
    if (drawer && result.sections?.['cart-drawer']) {
      drawer.renderContents(result);
      requestAnimationFrame(() => {
        const close = drawer.querySelector('.drawer__close');
        if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), close);
        else close?.focus();
      });
    } else window.location.reload();
  } catch (failure) {
    error.hidden = false;
    button.disabled = false;
  } finally {
    button.removeAttribute('aria-busy');
    gftAddingComplement = false;
  }
});

document.addEventListener('click',event=>{
  const checkout=event.target.closest('button[name="checkout"]');
  if(!checkout)return;
  const scope=checkout.closest('cart-drawer')||document.querySelector('#main-cart-footer');
  const missing=scope?.querySelector('[data-gft-invalid-size]');
  if(missing){event.preventDefault();event.stopImmediatePropagation();missing.scrollIntoView({block:'center'});missing.querySelector('a')?.focus()}
},true);
document.addEventListener('submit',event=>{
  if(!['CartDrawer-Form','cart'].includes(event.target.id))return;
  const scope=event.target.closest('cart-drawer')||document.querySelector('#main-cart-footer');
  const missing=scope?.querySelector('[data-gft-invalid-size]');
  if(missing){event.preventDefault();event.stopImmediatePropagation();missing.querySelector('a')?.focus()}
},true);
})();
